/* eslint-disable react/prop-types */
import { Modal, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import logoIne from 'assets/images/Logo_INE.png';
import logoUTF from 'assets/images/SIMAC_Logo.png';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { ESTADOS } from 'constants/nombresCatalogos';
import { jsPDF } from 'jspdf';

// eslint-disable-next-line no-unused-vars
export function PdfGeocercas({ open, callback, dataActa, ubicaciones, catalogos, map }) {
  const handleCancel = () => {
    callback(false);
  };
  if (!map) return <div />;
  const center = `${map.center.lat()},${map.center.lng()}`;
  const zoom = `${map.zoom}`;
  let pdfg = '';
  let ruta = `https://maps.googleapis.com/maps/api/staticmap?center=(centro)&zoom=(z)&size=900x500&maptype=roadmap&markers=color:blue%7Clabel:S%(Locaciones)&path=color:0xff0000ff|weight:5(Locaciones)&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;
  let markets = '';

  const entidades = useSelector(selectCatalogByName(ESTADOS));
  const emptyField = (field) => {
    console.log('campo', field);
    return field === null || field === undefined;
  };

  const getMunicipio = (idMunicipio, nombreEstado) => {
    if (emptyField(idMunicipio)) return '';
    const municipiosEntidad =
      entidades.find((e) => e.nombreEstado === nombreEstado)?.municipios || [];
    return municipiosEntidad.find((e) => e.idMunicipio === idMunicipio)?.nombreMunicipio;
  };

  const directionDefine = (punto, nombreEstado) => {
    const municipio = getMunicipio(punto.idMunicipio, nombreEstado);
    let direccion = `${'Calle: '}${emptyField(punto.calle) ? 'Sin registro' : punto.calle}${' '}${
      emptyField(punto.numero) ? '' : punto.numero
    }${', Colonia: '}${emptyField(punto.colonia) ? 'Sin registro' : punto.colonia}${' CP: '}${
      emptyField(punto.codigoPostal) ? 'Sin registro' : punto.codigoPostal
    }${' '}${municipio}, ${nombreEstado}`;
    if (emptyField(punto.calle) && emptyField(punto.colonia) && emptyField(punto.codigoPostal)) {
      console.log('Calle vacia');
      direccion = `Municipio: ${getMunicipio(punto.idMunicipio, nombreEstado)}, ${nombreEstado}`;
    }
    return direccion;
  };
  const generatePDF = () => {
    try {
      if (open === true) {
        let nombreEstado = '';
        let municipio = '';
        // eslint-disable-next-line array-callback-return
        catalogos.map((e) => {
          if (e.idEstado === dataActa.entidad) {
            nombreEstado = e.nombreEstado;
            // eslint-disable-next-line array-callback-return
            e.municipios.map((m) => {
              if (m.idMunicipio === dataActa.municipios) {
                municipio = m.nombreMunicipio;
              }
            });
          }
        });
        // eslint-disable-next-line array-callback-return
        ubicaciones.map((d) => {
          markets = `${markets}|${d.cordenadas.lat},${d.cordenadas.lng}`;
        });
        ruta = ruta.replace('(Locaciones)', markets);
        ruta = ruta.replace('(Locaciones)', markets);
        ruta = ruta.replace('(centro)', `${center}`);
        ruta = ruta.replace('(z)', zoom);
        // console.log('ruta', ruta);
        const hoy = new Date();
        const fecha = hoy.toLocaleDateString();
        // eslint-disable-next-line new-cap
        const doc = new jsPDF('p', 'pt', 'letter', true);
        const margins = {
          top: 60,
          bottom: 60,
          left: 30,
          width: 440
        };
        doc.setFont('helvetica', 'bold');
        doc.margins = margins;
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.addImage(logoUTF, 'png', 450, 15, 120, 35);
        doc.addImage(logoIne, 'png', 10, 15, 120, 35);
        doc.setFontSize(12);
        doc.text('Sistema Integral de Monitoreo de Actividades de Campo (SIMAC)', 300, 85, {
          align: 'center',
          lineHeightFactor: 1.5,
          maxWidth: 400
        });
        doc.text('Ruta de Monitoreo.', 300, 105, {
          align: 'center',
          lineHeightFactor: 1.5,
          maxWidth: 400
        });
        doc.setFontSize(10);
        doc.text(`${'Fecha de impresión: '}${fecha}`, 15, 145);
        doc.text(`${'Fecha de Ruta: '}${fecha}`, 15, 165);
        doc.text(`${'Estado: '}${nombreEstado}`, 15, 185);
        doc.text(`${'Alcaldia: '}${municipio}`, 15, 205);
        doc.setFontSize(10);
        let yLinea = 205;
        let yText = 205;

        // eslint-disable-next-line array-callback-return
        ubicaciones.map((d, index) => {
          const direccion = directionDefine(d, nombreEstado);
          const renglones = 13 * Math.floor(direccion.length / 100);
          yLinea += 21;
          yLinea += renglones;
          yText += 20;
          doc.setDrawColor(0, 0, 0);
          doc.line(35, yLinea, 580, yLinea);
          doc.setTextColor(149, 0, 84);
          doc.text(`${index + 1}`, 50, yText);
          doc.setTextColor(0, 0, 0);
          console.log(yLinea, yText, direccion.length, Math.round(direccion.length / 100));

          doc.text(`${direccion}`, 70, yText, {
            maxWidth: 500
          });
          yText += renglones;
        });

        yLinea += 20;

        if (yLinea < 550) {
          doc.text('Pagina 1 de 1', 520, 770);
          doc.addImage(ruta, 'png', 35, yLinea, 300, 220);
        } else {
          // Se agrega otra página para que el mapa se vea correctamente
          doc.text('Pagina 1 de 2', 520, 770);

          doc.addPage();
          doc.addImage(logoUTF, 'png', 450, 15, 120, 35);
          doc.addImage(logoIne, 'png', 10, 15, 120, 35);
          doc.setFontSize(12);
          doc.text('Sistema Integral de Monitoreo de Actividades de Campo (SIMAC)', 300, 85, {
            align: 'center',
            lineHeightFactor: 1.5,
            maxWidth: 400
          });
          yLinea = 100;
          doc.addImage(ruta, 'png', 35, yLinea, 300, 220);
          doc.text('Pagina 2 de 2', 520, 770);
        }
        pdfg = doc.output('dataurlstring');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal footer={null} width="40%" open={open} onCancel={handleCancel} centered>
      <Row>
        <Col span={4} />
        <Col span={18}>
          <h2 style={{ fontWeight: 'bold' }}>Geocercas</h2>
        </Col>
      </Row>
      <div>{generatePDF()}</div>
      <Row className="pdf">
        <embed
          style={{ width: '500px' }}
          src={pdfg}
          type="application/pdf"
          width="420px"
          height="630px"
        />
      </Row>
    </Modal>
  );
}
